import { Action, Dispatch } from 'redux'
import { db } from 'firebase/index'
import { CouponType } from 'types/coupon'
import { confirmCouponAction } from 'reducks/coupon/actions'

const fetchCoupon = (couponId: string) => {
  return async (dispatch: Dispatch<Action>) => {
    const coupon = await db
      .collection('coupons')
      .doc(couponId)
      .get()
      .then((snapshot) => {
        const data = snapshot.data() as CouponType
        data.coupon_id = couponId
        return data
      })
      .catch((error) => {
        console.error(error)
        return undefined
      })
    if (!coupon) return
    dispatch(confirmCouponAction(coupon))
  }
}

export default fetchCoupon
